import { api, type Page } from './client'

export interface CrmUser {
  id: number
  name: string
  email: string
  role: string
  isActive: boolean
  parentUserId: number | null
  userCategoryId: number | null
  lastLoginAt: string | null
  loginAttempts: number
  lockedUntil: string | null
  createdAt: string
}

export const usersApi = {
  list: (p?: { page?: number; search?: string; role?: string; isActive?: boolean; size?: number }) => {
    const params = new URLSearchParams()
    if (p?.page) params.set('page', String(p.page))
    if (p?.search) params.set('search', p.search)
    if (p?.role) params.set('role', p.role)
    if (p?.isActive !== undefined) params.set('isActive', String(p.isActive))
    if (p?.size) params.set('size', String(p.size))
    return api<Page<CrmUser>>(`/api/users?${params}`)
  },
  get: (id: number) => api<CrmUser>(`/api/users/${id}`),
  create: (data: { name: string; email: string; password: string; role: string; userCategoryId?: number | null; parentUserId?: number | null }) =>
    api<{ id: number }>('/api/users', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: { name: string; email: string; role: string; isActive: boolean; userCategoryId?: number | null; parentUserId?: number | null }) =>
    api<void>(`/api/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  resetPassword: (id: number, newPassword: string) =>
    api<void>(`/api/users/${id}/reset-password`, {
      method: 'POST',
      body: JSON.stringify({ newPassword }),
    }),
  unlock: (id: number) => api<void>(`/api/users/${id}/unlock`, { method: 'POST', body: '{}' }),
  resetMfa: (id: number) => api<void>(`/api/users/${id}/mfa/disable`, { method: 'POST', body: '{}' }),
  deactivate: (id: number) => api<void>(`/api/users/${id}`, { method: 'DELETE' }),
}

export const USER_ROLES = [
  'Administrator',
  'EqualAdmin',
  'EqualDirettoreGenerale',
  'EqualDirettoreCommerciale',
  'EqualAreaManager',
  'EqualAgenzia',
  'EqualAgente',
  'EqualSegnalatore',
  'EqualOperatore',
  'EqualBackOffice',
  // F-069: area amministrativa
  'EqualAmministrazione',
  'EqualCommercialista',
  'EqualSocio',
]
